class QuickBuyComponent extends HTMLElement {
    constructor() {
      super();
      this.openCardButton = this.querySelector('.card-quickbuy-open');
      this.addDefaultProduct = this.openCardButton?.hasAttribute('data-quick-buy-default-product');
      this.closeCardButton = this.querySelector('.card-quickbuy-close');
      this.quickbuyCard = this.querySelector('.card-quickbuy');
      this.quickBuyContainer = document.getElementById('quick-buy-container');
      this.quickBuyContent = document.getElementById('quick-buy-content');
      this.openCardButton?.addEventListener('click', (e) => this.openModal(e));
      this.closeCardButton?.addEventListener('click', (e) => this.closeModal(e));
    }
  
    openModal(e) {
      if (this.addDefaultProduct) {
        this.openCardButton.setAttribute('aria-disabled', true);
        this.openCardButton.classList.add('loading');
        this.openCardButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');
        const addToCardButton = this.quickbuyCard.querySelector('.product-form__submit');
        addToCardButton?.click();
        setTimeout(() => {
          this.openCardButton.classList.remove('loading');
          this.openCardButton.removeAttribute('aria-disabled');
          this.openCardButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
        }, 1000);
        return;
      }
      if (this.openCardButton.hasAttribute('data-quick-buy-compose-bundle')) return;
      let windowWidth = window.innerWidth;
      if(windowWidth > 989) {
        this.quickbuyCard.classList.add('visible');
        this.closest('.buly-card-product').classList.add('show-overflow');
        document.body.classList.add('quickbuy-visible');
      } else {
        let productFormClone = this.quickbuyCard.cloneNode(true);
        productFormClone.querySelectorAll('.product-form__input--color input').forEach(
          (inputId) => {
            inputId.id = inputId.id + "_mobile-quickbuy"
          }
        );
        productFormClone.querySelectorAll('.product-form__input--color label').forEach(
          (labelFor) => {
            labelFor.htmlFor = labelFor.htmlFor + "_mobile-quickbuy"
          }
        );
        this.quickBuyContent.appendChild(productFormClone);
        document.body.classList.add('quickbuy-visible');
      }
    }
  
    closeModal(e) {
      let windowWidth = window.innerWidth;
      if(windowWidth > 989) {
        this.quickbuyCard.classList.remove('visible');
        this.closest('.buly-card-product').classList.remove('show-overflow');
      } else {
        document.body.classList.remove('quickbuy-visible');
      }
    }
  }
  
  customElements.define('card-quickbuy', QuickBuyComponent);


let cloneClose = document.getElementById('quickbuy-close');
cloneClose.addEventListener('click', function(e){
  e.preventDefault();
  document.getElementById('quick-buy-content').innerHTML = '';
  document.querySelector('body').classList.remove('quickbuy-visible');
});